<!--
    NOTE:
        I spent a few hours trying to comprehend the cdk drag drop mechanisms and although it does lots of good things, the bad things were hard to overcome.

        I found that ng-drag-drop provided the simplest and cleanest looking mechanism to drag items around, however, it is limited in what it gives us in terms of reordering items.
        It gave me something I could work with conceptually though, so I went with it to give us something, it may not be the best or final choice for drag and drop

    -->
<mat-drawer-container class="drawer-container" autosize>
    <div class="action-bar" tabindex="-1" id="form-controls-div">

        <!-- Form Template Display & Editor -->
        <div class="form-title" *ngIf="!this.IsEditingFormName; else templFormName">
            <span class="form-name">
                {{form.name}}
            </span>
            <ng-container *ngIf="this.CanEditTemplateProperties">
                <span class="rename-button">
                    <mat-icon matTooltip="Rename form" (click)="editTemplateNameClick()">edit</mat-icon>
                </span>
            </ng-container>
        </div>

        <ng-template #templFormName>
            <input matInput
                   #formNameInput
                   class="entity-rename-input"
                   type="text"
                   [(ngModel)]="form.name"
                   placeholder="Form name"
                   (keyup.enter)="applyFormTemplateName()"
                   (keyup.escape)="cancelRename()"
                   size="60"
                   maxlength="256"
                   autocomplete="off"
                   required />
            <span (click)="applyFormTemplateName()" class="save-icon">
                <mat-icon title="Save the edited name for this form">check</mat-icon>
            </span>
            <span (click)="cancelRename()" class="cancel-icon">
                <mat-icon title="Cancel rename form">cancel</mat-icon>
            </span>
        </ng-template>

        <div class="flex-grow-one"></div>

        <!-- Define a trash can for deleting form fields and layout rows. -->
        <div [ngClass]="this.DraggedObject !== null ? 'enabled-trash-div' : 'disabled-trash-div'"
             droppable
             [dropScope]="['layoutCell','row']"
             [dragOverClass]="this.DraggedObject !== null ? 'drag-over' : 'drop-not-allowed'"
             (onDrop)="this.onObjectDroppedOnTrash($event)">
            <mat-icon svgIcon="trash"
                      class="trash-mat-icon"
                      matTooltip="{{this.TrashCanTooltip}}"
                      [matTooltipPosition]="this.TooltipPosition"></mat-icon>
        </div>

        <ng-container *ngIf="this.CanEditTemplateProperties">
            <mat-button-toggle-group class="action-item"
                                     [(ngModel)]="this.SelectedIndex"
                                     (ngModelChange)="formModeSelectionChanged()">
                <mat-button-toggle [value]="0"
                                   matTooltip="{{this.DesignButtonTooltip}}"
                                   [matTooltipPosition]="this.TooltipPosition">Design</mat-button-toggle>
                <mat-button-toggle [value]="1"
                                   matTooltip="{{this.PreviewButtonTooltip}}"
                                   [matTooltipPosition]="this.TooltipPosition">Preview</mat-button-toggle>
            </mat-button-toggle-group>
        </ng-container>

        <!-- Note:  still need to test the two CSS classes used with the following button. -->
        <ng-container *ngIf="this.CanEditTemplateProperties">
            <button mat-flat-button
                    class="action-item settings-btn"
                    disabled="{{DisableFormSettings}}"
                    color="basic"
                    (click)="formSettingsClick()"
                    matTooltip="Settings for this Form"
                    [matTooltipPosition]="this.TooltipPosition">
                <mat-icon aria-hidden="false"
                          aria-label="Form settings">settings</mat-icon>
            </button>

            <button mat-flat-button
                    class="action-item settings-btn field-conditional-logic-rules-button"
                    disabled="{{DisableFieldConditionalLogicRules}}"
                    (click)="editFieldConditionalLogicRules()"
                    matTooltip="Field Conditional Logic Rules"
                    [matTooltipPosition]="this.TooltipPosition">
                Rules
            </button>

            <button mat-flat-button
                    class="action-item settings-btn field-conditional-logic-rules-button"
                    disabled="{{DisableEditFormFieldNames}}"
                    (click)="editFormFieldNames()"
                    matTooltip="Edit Form Field Names"
                    [matTooltipPosition]="this.TooltipPosition">
                Field Names
            </button>
        </ng-container>

        <button mat-flat-button
                disabled="{{DisableFormSave}}"
                class="action-item theme-primary-btn"
                (click)="save()"
                matTooltip="Save changes to this Form"
                [matTooltipPosition]="this.TooltipPosition">
            <mat-icon aria-hidden="false"
                      aria-label="Save form design">save</mat-icon>
        </button>
    </div>


        <mat-tab-group [selectedIndex]="this.SelectedIndex" id="matTabGroup">
            <mat-tab>
                <ng-template matTabContent>
                    <div class="row form-builder">
                        <div appFluidHeight topOffset="{{FluidHeightTopOffset}}" [ngClass]="
                         {
                            'sticky-toolbox-hard-left':this.FreezeToolbox=='sideNavClosed',
                            'sticky-toolbox-left':this.FreezeToolbox=='sideNavOpen',
                            'toolbox':this.FreezeToolbox==null
                         }">
                            <!-- Show available form fields on the left side of the page. -->
                            <ng-container *ngIf="this.CanEditTemplateProperties">
                                <mat-accordion>
                                    <mat-expansion-panel *ngFor="let group of this.FieldGroups"
                                                         [expanded]="group == this.InitiallyExpandedFieldGroup"
                                                         id="{{this.sanitizeFieldGroupName(group)}}">
                                        <mat-expansion-panel-header [expandedHeight]="'40px'">
                                            {{group}}
                                        </mat-expansion-panel-header>

                                        <mat-list>
                                            <ng-container *ngFor="let fieldDef of this.FieldDefinitions | filter : 'toolBoxGroup' : group">
                                                <ng-container *ngIf="this.ShowFieldDefAsTool(fieldDef)">
                                                    <ng-container *ngIf="fieldDef.canBeDroppedOnForm || fieldDef.canBeDroppedOnGrid || fieldDef.canBeDroppedOnSiteHomePage">
                                                        <mat-list-item [ngClass]="{disabled:!Form.CurrentUserCanBuildForms}"
                                                                       draggable
                                                                       [dragScope]="FieldDefDragScope(fieldDef)"
                                                                       [dragData]="fieldDef"
                                                                       matTooltip="{{fieldDef.description}}"
                                                                       [matTooltipPosition]="this.FormFieldTooltipPosition"
                                                                       (dblclick)="this.onFieldDefinitionDoubleClick(fieldDef)">
                                                            <mat-icon *ngIf="fieldDef.iconType == 'MaterialIcon'"
                                                                      class="field-type-icon"
                                                                      mat-list-icon>{{fieldDef.iconName}}</mat-icon>
                                                            <mat-icon *ngIf="fieldDef.iconType == 'SVGIcon'"
                                                                      class="field-type-icon"
                                                                      svgIcon="{{fieldDef.iconName}}"
                                                                      mat-list-icon></mat-icon>

                                                            <span>{{fieldDef.displayName}}</span>
                                                        </mat-list-item>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </mat-list>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel *ngIf="this.DeletedFields?.length">
                                        <mat-expansion-panel-header>
                                            Deleted Fields
                                        </mat-expansion-panel-header>
                                        <mat-list>
                                            <ng-container *ngFor="let delField of this.DeletedFields">
                                                <mat-list-item [ngClass]="{disabled:!Form.CurrentUserCanBuildForms}"
                                                               draggable
                                                               [dragScope]="DeletedFieldDragScope()"
                                                               [dragData]="delField"
                                                               matTooltip="{{delField.toolTip}} deleted {{delField.modifiedDate | date: 'MM/dd/yyyy hh:mm'}}"
                                                               [matTooltipPosition]="this.FormFieldTooltipPosition">
                                                    <mat-icon *ngIf="delField.iconType == 'MaterialIcon'"
                                                              mat-list-icon>{{delField.iconName}}</mat-icon>
                                                    <mat-icon *ngIf="delField.iconType == 'SVGIcon'"
                                                              svgIcon="{{delField.iconName}}"
                                                              mat-list-icon></mat-icon>

                                                    <span>{{this.deletedFieldDisplayName(delField)}}</span>
                                                </mat-list-item>
                                            </ng-container>
                                        </mat-list>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </ng-container>
                        </div>
                        <!-- Show the preview version of a form. -->
                        <div appFluidHeight topOffset="{{FluidHeightTopOffset}}" [ngClass]="{'margined-form-canvas':this.FreezeToolbox, 'form-canvas': !this.FreezeToolbox}">
                            <mat-card appearance="outlined">
                                <mat-card-content>
                                    <div *ngFor="let row of form.formLayout.rows"
                                         class="form-row"
                                         droppable
                                         [dropScope]="'row'"
                                         draggable
                                         [dragHandle]="'.drag-handle'"
                                         [dragScope]="'row'"
                                         [dragData]="row"
                                         (onDragStart)="onRowDragStart($event, row)"
                                         (onDragEnd)="onDragEnd($event)"
                                         [dragHintClass]="'drag-hint'"
                                         [dragOverClass]="getDragClass(row, 'drag-over')"
                                         (onDrop)="onDropRow($event, row)"
                                         (click)="onRowSelect($event, row)"
                                         [ngClass]="{ 'selected': row.isSelected }"
                                         (contextmenu)="onContextMenu($event, row)">
                                        <div class="row form-canvas-row">
                                            <div *ngFor="let cell of row.cells"
                                                 [class]="this.GridCellClass(cell)">
                                                <div class="layout-cell"
                                                     style="{{this.layoutCellStylesFor(cell)}}"
                                                     droppable
                                                     [dropScope]="'field'"
                                                     draggable
                                                     [dragScope]="['field','layoutCell']"
                                                     [dragData]="cell"
                                                     (onDragStart)="onRowCellDragStart($event, row, cell)"
                                                     (onDragEnd)="onDragEnd($event)"
                                                     [dragHintClass]="'drag-hint'"
                                                     [dragOverClass]="getDragClass(cell, 'drag-over')"
                                                     (onDrop)="onDrop($event, row, cell)"
                                                     (click)="onCellSelect($event, cell)"
                                                     (dblclick)="this.onCellDoubleClick(cell)"
                                                     [ngClass]="{ 'selected': cell.isSelected }">
                                                    <div *ngIf="cell.formFieldId > 0 || cell.name"
                                                         class="form-field">
                                                        <ng-container *ngIf="this.canEditField(cell.formFieldId)">
                                                            <app-form-field-wrapper [formField]="getFormField(cell.formFieldId, cell.name)"
                                                                                    [mode]="'design'"
                                                                                    [canEditProperties]="true"
                                                                                    (onInit)="formFieldOnInit($event, cell)"
                                                                                    (onEdit)="formFieldEdit($event, cell)"
                                                                                    (designChange)="flagDirty()">
                                                            </app-form-field-wrapper>
                                                        </ng-container>
                                                        <ng-container *ngIf="!this.canEditField(cell.formFieldId)">
                                                            <app-form-field-wrapper [formField]="getFormField(cell.formFieldId, cell.name)"
                                                                                    [mode]="'design'"
                                                                                    [canEditProperties]="false"
                                                                                    (onInit)="formFieldOnInit($event, cell)"
                                                                                    (onEdit)="noopFormFieldEdit($event, cell)"
                                                                                    (designChange)="flagDirty()">
                                                            </app-form-field-wrapper>
                                                        </ng-container>
                                                    </div>
                                                </div>

                                                <!-- Cell selection checkbox. -->
                                                <ng-container *ngIf="this.ShowCellSelectionCheckboxes">
                                                    <div class="cell-selection-div">
                                                        <mat-checkbox [(ngModel)]="cell.isSelected"
                                                                      (ngModelChange)="this.onCellSelectionCheckboxChanged(cell)"
                                                                      (click)="this.onCellSelectionCheckboxClicked($event,cell)"
                                                                      (dblclick)="this.onCellSelectionCheckboxDoubleClicked($event,cell)"
                                                                      class="cell-selection-mat-checkbox"
                                                                      matTooltip="{{this.CellSelectionCheckboxTooltip}}"
                                                                      [matTooltipPosition]="this.TooltipPosition"></mat-checkbox>
                                                    </div>
                                                </ng-container>
                                            </div>

                                        </div>
                                        <div class="row-action">
                                            <mat-icon mat-list-icon
                                                      class="drag-handle">drag_indicator</mat-icon>
                                        </div>

                                    </div>

                                    <app-context-menu #rowContextMenuComponent
                                                      [contextMenuData]="this.RowContextMenuData"
                                                      [menuName]="'rowContextMenuComponent'"
                                                      style="visibility: hidden; position: fixed"></app-context-menu>

                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template matTabContent>
                    <app-form-renderer [form]="form"
                                       [mode]="'preview'"></app-form-renderer>
                </ng-template>
            </mat-tab>
        </mat-tab-group>



        <!-- Note:  the following drawer, when displayed, will only show one of the specified components. -->
        <mat-drawer #drawer
                    mode="over"
                    position="end"
                    class="drawer-fixed"
                    [ngClass]="'properties-drawer'"
                    (closedStart)="drawerClosing()">
            <app-form-field-properties *ngIf="this.SelectedField"
                                       (configureFlex)="doFlexConfig(this.SelectedField.id, this.SelectedField.name)"
                                       [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-form-field-properties>

            <app-form-properties *ngIf="this.EditForm"
                                 [drawerComponentLiaison]="this.DrawerComponentLiaison"></app-form-properties>

        </mat-drawer>
</mat-drawer-container>
